import React, { useContext } from 'react';
import { Breadcrumb } from '@ktag/styleguide/dist/react';
import BreadcrumbsContext from './BreadcrumbsContext';

const WAPBreadcrumbs = () => {
  const { currentItems, navigationCurrent, navigationSource } =
    useContext(BreadcrumbsContext);

  return (
    <Breadcrumb
      items={currentItems}
      navigationCurrent={navigationCurrent}
      navigationSource={navigationSource}
    />
  );
};

export default WAPBreadcrumbs;
